export const getNotificationsItems = (state) => state.notifications.notifications
export const getIsLoadingNotifications = (state) => state.notifications.isLoading
export const getNotificationsPagination = (state) => state.notifications.pagination